import { sd } from "@sd/lib/sdPaths";
import { looksLikeUuid } from "@sd/lib/ticketRowMapping";
import { buildTicketDetailPath } from "@sd/lib/ticketDetailPath";

/** Frontend URL for ticket links in notification emails. */
export function buildTicketEmailViewPath(ticketId: string): string {
  const id = ticketId.trim();
  if (!id) return sd("tickets");
  return buildTicketDetailPath(id);
}

/** Shorter email link: `/sd/ticket/{uuid}` */
export function buildTicketEmailShortPath(ticketId: string): string {
  const id = ticketId.trim();
  if (!id) return sd("tickets");
  return sd(`ticket/${encodeURIComponent(id)}`);
}

export function parseTicketIdFromEmailSegment(segment: string | undefined): string | null {
  const t = (segment ?? "").trim();
  return looksLikeUuid(t) ? t : null;
}

export function isEmailTicketUuidSegment(segment: string | undefined): boolean {
  return parseTicketIdFromEmailSegment(segment) !== null;
}
